import { initialState } from '../reducers/containers';
import { peek, selector } from '../selectorHelpers';

export const containersSelect = (state) =>
  state.get('containers', initialState);

// Container list: List([ContainerSummary, ...])
export const containersSelectItems = selector(containersSelect, peek('items'));

export const containersSelectLoading = selector(
  containersSelect,
  peek('isLoading'),
);

// Container detail cache: Map { containerId: ContainerDetail }
export const containersSelectDetailed = selector(
  containersSelect,
  peek('detailedContainer'),
);

export const containersSelectDetailedLoading = selector(
  containersSelect,
  peek('isDetailedLoading'),
);
